function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { ConfigProvider, Tag } from 'antd';
import classNames from 'classnames';
import React, { useState } from 'react';
//// 如果需要用到主题的样式就可以引入主题样式测试，在打包的时候需要删除
//import '../njoyd.less';
// 组件自己的样式
import { antdTheme, njoydTheme } from "../theme";
import "./styles/index.less";
var CheckableTag = Tag.CheckableTag;
var CheckTag = function CheckTag(props) {
  // antd 原生主题对象
  var antd = antdTheme(props.theme);
  // njoyd 原生主题对象
  var njoyd = njoydTheme();
  var className = props.className,
    style = props.style,
    _props$hideCheckAll = props.hideCheckAll,
    hideCheckAll = _props$hideCheckAll === void 0 ? false : _props$hideCheckAll,
    expandable = props.expandable,
    option = props.option,
    _props$actionsText = props.actionsText,
    actionsText = _props$actionsText === void 0 ? {} : _props$actionsText,
    initValue = props.value,
    handleChange = props.handleChange,
    borderRadius = props.borderRadius;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expand = _useState2[0],
    setExpand = _useState2[1];
  var _useState3 = useState(initValue || []),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];

  //const isTagSelectOption = (node: TagSelectOptionElement) =>
  //  node &&
  //  node.type &&
  //  (node.type.isTagSelectOption || node.type.displayName === 'TagSelectOption');

  var getAllTags = function getAllTags() {
    var checkedTags = option.map(function (item) {
      return item.value;
    });
    return checkedTags || [];
  };
  var onSelectAll = function onSelectAll(checked) {
    var checkedTags = [];
    if (checked) {
      checkedTags = getAllTags();
    }
    setValue(checkedTags);
  };
  var handleTagChange = function handleTagChange(tag, checked) {
    var checkedTags = [];
    var index = checkedTags.indexOf(tag);
    if (checked && index === -1) {
      checkedTags.push(tag);
    } else if (!checked && index > -1) {
      checkedTags.splice(index, 1);
    }
    setValue(checkedTags);
    handleChange();
  };
  var checkedAll = getAllTags().length === (value === null || value === void 0 ? void 0 : value.length);
  var _actionsText$expandTe = actionsText.expandText,
    expandText = _actionsText$expandTe === void 0 ? '展开' : _actionsText$expandTe,
    _actionsText$collapse = actionsText.collapseText,
    collapseText = _actionsText$collapse === void 0 ? '收起' : _actionsText$collapse,
    _actionsText$selectAl = actionsText.selectAllText,
    selectAllText = _actionsText$selectAl === void 0 ? '不限' : _actionsText$selectAl;
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    theme: {
      token: antd
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames({
      njoy_tagSelect: true,
      className: className,
      njoy_hasExpandTag: expandable,
      njoy_expanded: expand
    }),
    style: _objectSpread(_objectSpread({}, style), {}, {
      backgroundColor: njoyd.colorBgBase || '#fff',
      color: njoyd.colorPrimary || '#1677ff',
      borderColor: njoyd.colorBgBase || '#fff'
    })
  }, hideCheckAll ? null : /*#__PURE__*/React.createElement(CheckableTag, {
    className: "njoy_item_tag",
    checked: checkedAll || !value.length,
    key: "tag-select-__all__",
    onChange: onSelectAll,
    style: {
      borderRadius: borderRadius || njoyd.borderRadius
    }
  }, selectAllText), option && option.map(function (item) {
    return /*#__PURE__*/React.createElement(CheckableTag, {
      key: "tag-select-".concat(item.value),
      checked: value && value.indexOf(item.value) > -1 && !checkedAll,
      onChange: function onChange(checked) {
        return handleTagChange(item.value, checked);
      },
      className: "njoy_item_tag",
      style: {
        borderRadius: borderRadius || njoyd.borderRadius
      }
    }, item.label);
  }), expandable && /*#__PURE__*/React.createElement("a", {
    className: "njoy_tag_trigger",
    onClick: function onClick() {
      setExpand(function (expand) {
        return !expand;
      });
    }
  }, expand ? /*#__PURE__*/React.createElement(React.Fragment, null, collapseText, /*#__PURE__*/React.createElement(UpOutlined, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, expandText, /*#__PURE__*/React.createElement(DownOutlined, null)))));
};
export default CheckTag;